// extracted by mini-css-extract-plugin
module.exports = {"page":"SettingsPage_page__1FDiq","title":"SettingsPage_title__1EAgz","section":"SettingsPage_section__2Ztk_","subtitle":"SettingsPage_subtitle__1b4mG"};